const update_sql1 = [`select val from t_version;`];
export default update_sql1;
